/** A schema to describe the Company Activity slice. */
export const FacetSearchCompanyActivitySlice = {
    selected: null
}
